// Bar widths are self-assessed proficiency, rendered as inline width styles.
export const codingSkills = [
  { name: "Python", level: "95%" },
  { name: "Go", level: "85%" },
  { name: "TypeScript / JavaScript", level: "90%" },
  { name: "Java", level: "80%" },
  { name: "C++", level: "85%" },
  { name: "SQL", level: "80%" },
];

export const frameworkSkills = [
  { name: "React", level: "95%" },
  { name: "Node", level: "90%" },
  { name: "Next.js", level: "85%" },
  { name: "Flask", level: "85%" },
  { name: "FastAPI", level: "80%" },
  { name: "Spring Boot", level: "75%" },
];

export const languageSkills = [
  { name: "English", level: "100%" },
  { name: "Portuguese", level: "100%" },
  { name: "Spanish", level: "50%" },
];

export const knowledgeList = [
  "Network Engineering (Fiber Infrastructure, Network Design, Protocols)",
  "Full-Stack Development (React, Node.js, Flask)",
  "Cloud Platforms (AWS, Azure)",
  "Network Security & ML (Federated Learning, Intrusion Detection)",
  "Agile & Project Management (Scrum, Kanban)",
];
